import Iconify from "../ui/Iconify";

const SearchTriggerForm = ({
  searchState,
  searchActions,
  desktopNavigationState,
  placeholder,
}) => {
  const { search, setSearch, searchInFocus } = searchState;
  const {
    openSearch,
    closeSearch,
    routeToSearch,
    routeToBestSearchTarget = routeToSearch,
  } = searchActions;

  return (
    <form
      onKeyDown={desktopNavigationState?.onKeyDown}
      onSubmit={(e) => {
        e.preventDefault();
        const inputValue = e.currentTarget?.querySelector?.("input")?.value;
        routeToBestSearchTarget(inputValue || search);
      }}
      className={`flex h-12 items-center justify-between gap-2 rounded-full border px-4 transition md:h-auto md:px-3.5 md:py-2 ${
        searchInFocus
          ? "border-black/25 bg-white shadow-[0_0_0_3px_rgba(0,0,0,0.05)] dark:border-white/30 dark:bg-white/10"
          : "border-transparent bg-light_bg_grey dark:bg-dark_bg_grey"
      } w-full`}
    >
      <button
        type="submit"
        aria-label="검색"
        className="hidden h-7 w-7 shrink-0 items-center justify-center text-light_secondary_label md:flex"
      >
        <Iconify icon="lucide:search" className="!h-5 !w-5" />
      </button>
      <input
        type="text"
        placeholder={placeholder}
        onFocus={openSearch}
        required
        className="grow bg-transparent text-[17px] font-medium leading-5 outline-none dark:placeholder:text-neutral-500 md:text-base md:font-normal"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          desktopNavigationState?.setActiveIndex?.(-1);
        }}
      />
      <div className="flex items-center gap-4">
        {(search?.length > 0 || searchInFocus) && (
          <Iconify
            icon="lucide:x"
            className="!h-6 !w-6 cursor-pointer text-light_secondary_label hover:text-light_primary_label md:!h-5 md:!w-5"
            onClick={() => {
              if (search) {
                setSearch("");
                return;
              }
              closeSearch();
            }}
          />
        )}
        <button type="submit" className="md:hidden">
          <Iconify
            icon="lucide:search"
            className="!h-6 !w-6 text-light_secondary_label hover:text-light_primary_label md:!h-5 md:!w-5"
            onClick={() => {
              routeToBestSearchTarget(search);
            }}
          />
        </button>
      </div>
    </form>
  );
};

export default SearchTriggerForm;
